/**
 * IT Companies - SLA Compliance Report Page
 * Track project delivery against SLA targets
 */

import { useEffect } from 'react';
import { SLAComplianceReport } from '@/components/industry/reports';
import { useIndustryProjects } from '@/hooks/industry';
import { CompanyType } from '@/types/company';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { MainLayout } from "@/components/MainLayout";

export default function ITCompaniesSLAReportPage() {
  useEffect(() => {
    document.title = 'Relatório de SLA | Controle Financeiro';
  }, []);

  const { projects, isLoading } = useIndustryProjects({ domain: CompanyType.IT_COMPANIES });

  const { data: company } = useQuery({
    queryKey: ['current_company'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data } = await supabase
        .from('companies')
        .select('*')
        .eq('user_id', user.id)
        .single();

      return data;
    },
  });

  const { data: clients = [] } = useQuery({
    queryKey: ['clients', company?.id],
    queryFn: async () => {
      if (!company) return [];

      const { data } = await supabase
        .from('clients')
        .select('id, name')
        .eq('company_id', company.id)
        .eq('is_active', true)
        .order('name');

      return data || [];
    },
    enabled: !!company,
  });

  const clientMap = clients.reduce((acc, client) => {
    acc[client.id] = client.name;
    return acc;
  }, {} as Record<number, string>);

  if (isLoading) {
    return (
<MainLayout>
      <div className="container mx-auto py-6">
        <div className="flex items-center justify-center py-12">
          <div className="text-muted-foreground">Carregando relatório...</div>
        </div>
      </div>
    
    </MainLayout>);
  }

  return (
<MainLayout>
    <div className="container mx-auto py-6">
      <SLAComplianceReport
        projects={projects || []}
        clientMap={clientMap}
      />
    </div>
  
    </MainLayout>);
}

